import { GetAllContactsInDto, GetAllContactsOutDto } from '../../../types/contact.dto'

export const GET_ALL_CONTACTS = 'GET_ALL_CONTACTS'
export const GET_ALL_CONTACTS_SUCCESS = 'GET_ALL_CONTACTS_SUCCESS'
export const GET_ALL_CONTACTS_ERROR = 'GET_ALL_CONTACTS_ERROR'
export const RESET_GET_ALL_CONTACTS = 'RESET_GET_ALL_CONTACTS'
export const UPDATE_CONTACTS = 'UPDATE_CONTACTS'

export interface GetAllContacts {
  type: typeof GET_ALL_CONTACTS
  payload: GetAllContactsOutDto
}

export interface GetAllContactsSuccess {
  type: typeof GET_ALL_CONTACTS_SUCCESS
  payload: GetAllContactsInDto
}

export interface GetAllContactsError {
  type: typeof GET_ALL_CONTACTS_ERROR
  payload: string | boolean
}

export interface ResetGetAllContacts {
  type: typeof RESET_GET_ALL_CONTACTS
  payload: null
}

export interface UpdateContacts {
  type: typeof UPDATE_CONTACTS
  payload: GetAllContactsInDto
}

export interface State {
  data: GetAllContactsInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions =
  | GetAllContacts
  | GetAllContactsSuccess
  | GetAllContactsError
  | ResetGetAllContacts
  | UpdateContacts
